export interface IMasterDataDistributionCenter {
  distributionCenterId: number;
  purchaserId: number;
  dcCode: string;
  dcName: string;
  createdAt: string | null;
  purchaserName: string | null;
  purchaserKey: string | null;
}

export class MasterDataDistributionCenter {
  private readonly _distributionCenterId: number;
  private readonly _purchaserId: number;
  private readonly _dcCode: string;
  private readonly _dcName: string;
  private readonly _createdAt: string | null;
  private readonly _purchaserName: string | null;
  private readonly _purchaserKey: string | null;

  constructor(props: IMasterDataDistributionCenter) {
    this._distributionCenterId = props.distributionCenterId;
    this._purchaserId = props.purchaserId;
    this._dcCode = props.dcCode;
    this._dcName = props.dcName;
    this._createdAt = props.createdAt;
    this._purchaserName = props.purchaserName;
    this._purchaserKey = props.purchaserKey;
  }

  get distributionCenterId(): number {
    return this._distributionCenterId;
  }
  get purchaserId(): number {
    return this._purchaserId;
  }
  get dcCode(): string {
    return this._dcCode;
  }
  get dcName(): string {
    return this._dcName;
  }
  get createdAt(): string | null {
    return this._createdAt;
  }
  get purchaserName(): string | null {
    return this._purchaserName;
  }
  get purchaserKey(): string | null {
    return this._purchaserKey;
  }

  static from(props: IMasterDataDistributionCenter): MasterDataDistributionCenter {
    return new MasterDataDistributionCenter(props);
  }

  static toJSON(
    entity: MasterDataDistributionCenter,
  ): IMasterDataDistributionCenter {
    return {
      distributionCenterId: entity.distributionCenterId,
      purchaserId: entity.purchaserId,
      dcCode: entity.dcCode,
      dcName: entity.dcName,
      createdAt: entity.createdAt,
      purchaserName: entity.purchaserName,
      purchaserKey: entity.purchaserKey,
    };
  }
}
